/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import LoadingIndicator from "@atg/icf-react-components/components/LoadingIndicator";
import { FC } from "react";
import { createPortal } from "react-dom";
import { createUseStyles } from "react-jss";

import cbLogoImg from "~/assets/images/cb_logo.svg";

const useStyles = createUseStyles({
  pageLoader: {
    position: "fixed",
    top: 0,
    // eslint-disable-next-line @atg/css-rtl-support
    left: 0,
    width: "100%",
    height: "100%",
    background: "#000000",
    display: "flex",
    justifyContent: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: "173px",
    display: "block",
    marginBottom: "32px",
  },
});

const AppLoader: FC = () => {
  const classes = useStyles();

  const portalContent = (
    <section className={classes.pageLoader}>
      <div className={classes.content}>
        <img className={classes.logo} src={cbLogoImg} alt="Cambuilder Logo" />

        <LoadingIndicator size={45} />
      </div>
    </section>
  );

  return createPortal(portalContent, document.body);
};

export default AppLoader;
